import { render, staticRenderFns } from "./SurfacePostAttachment.vue?vue&type=template&id=e9bf0f6e&"
import script from "./SurfacePostAttachment.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostAttachment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports